import { AvailabilityRequestType } from "@app/availability/constants/AvailabilityRequestType";

import { IBookingEngineState } from "../../types";

export const stateToAvailabilitySearchParams = (state: IBookingEngineState, requestType?: AvailabilityRequestType): URLSearchParams => {
    const bookingState = state.bookingState;
    const params = new URLSearchParams();

    params.set("rt", String(requestType || AvailabilityRequestType.Get));

    if (bookingState?.dates?.fromDate && bookingState?.dates?.toDate) {
        params.set("ci", bookingState.dates.fromDate);
        params.set("co", bookingState.dates.toDate);
    }

    if (state.promoCode) {
        params.set("pc", state.promoCode);
    }

    if (state.corpCode) {
        params.set("cc", state.corpCode);
    }

    if (requestType && requestType > 0) {
        params.set("lg", state.language);
        params.set("cu", state.currency);
    }

    (bookingState?.bookings || []).forEach((b, i) => {
        params.set(`rs[${i}][id]`, b.id);
        params.set(`rs[${i}][ac]`, b.adultsCount.toString());

        Object.entries(b.childCount).forEach(([categoryId, count]) => {
            params.set(`rs[${i}][cc][${categoryId}]`, count.toString());
        });

        if (requestType && requestType > 0 && b.rate?.id && b.room?.id) {
            params.set(`rs[${i}][ra]`, b.rate.id.toString());
            params.set(`rs[${i}][ro]`, b.room.id.toString());

            b.extras.forEach((extra, j) => {
                params.set(`rs[${i}][ex][${j}]`, extra.id);
            });
        }
    });

    return params;
};
